<!-- 盘盈盘亏列表 -->
<template>
    <div style="background-color: #ffffff;height: calc(100vh - 85px);display: flex;flex-direction: column;overflow: hidden;">
        <div style="flex-shrink: 0;">
            <el-form class="demo-form-inline" :inline="true" ref="pylkSearchForm" :model="pylkSearchForm"
                size="mini" label-width="100px">
                <el-form-item label="盈亏类型" prop="plType">
                    <el-select placeholder="请选择盈亏类型" v-model="pylkSearchForm.plType" clearable>
                        <el-option v-for="item in plTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入库单号" prop="billNo">
                    <el-input v-model="pylkSearchForm.billNo" placeholder="请输入入库单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="责任人" prop="responsible">
                    <el-input v-model="pylkSearchForm.responsible" placeholder="请输入提单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="盈亏原因" prop="reason">
                    <el-input v-model="pylkSearchForm.reason" placeholder="请输入提单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="提单号" prop="blNo">
                    <el-input v-model="pylkSearchForm.blNo" placeholder="请输入提单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="货名" prop="goodsName">
                    <el-input v-model="pylkSearchForm.goodsName" placeholder="请输入货名" clearable></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate">
                    <el-date-picker v-model="createDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getCreateDate"> </el-date-picker>
                </el-form-item>
                <el-form-item label="">
                    <el-button size="mini" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="mini" @click="wmsGetPylkList">搜索</el-button>
                    <el-button type="success" size="mini" @click="addPylk">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="flex:1;overflow: hidden">
            <vxe-table id="pylkTable" size="mini" ref="pylkTable" :data="pylkList" border stripe
                :column-config="{resizable: true,sortable: true}" header-align="center" :row-config="{ isHover: true}"
                :radio-config="{labelField: '', highlight: true}" height="auto" @cell-dblclick="getPylkDetailDblclick">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="plType" title="盈亏类型" width="100" fixed="left" sortable>
                    <template v-slot="{ row }">
                        <el-tag v-if="row.plType === '盘盈'" type="success" size="mini">盘盈</el-tag>
                        <el-tag v-else-if="row.plType === '盘亏'" type="danger" size="mini">盘亏</el-tag>
                        <span v-else>{{row.plType}}</span>
                    </template>
                </vxe-column>
                <vxe-column field="ckName" title="仓库" min-width="130" ></vxe-column>
                <vxe-column field="billNo" title="入库单号" min-width="130">
                    <template v-slot="{ row }">
                        <el-link type="primary" @click="getPylkDetails(row)">{{row.billNo}}</el-link>
                    </template>
                </vxe-column>
                <vxe-column field="blNo" title="提单号" min-width="130"></vxe-column>
                <vxe-column field="boxNo" title="箱号" min-width="130"></vxe-column>
                <vxe-column field="goodsName" title="货名" min-width="130"></vxe-column>
                <vxe-column field="ownerName" title="货主单位" min-width="130"></vxe-column>
                <vxe-column field="spec" title="规格" min-width="110"></vxe-column>
                <vxe-column field="qty1" title="件数" width="90"></vxe-column>
                <vxe-column field="netWeight" title="净重(KG)" width="110"></vxe-column>
                <vxe-column field="decPrice" title="单价" width="100"></vxe-column>
                <vxe-column field="reason" title="盈亏原因" min-width="130"></vxe-column>
                <vxe-column field="responsible" title="责任人" min-width="130"></vxe-column>
                <vxe-column field="operator" title="操作员" width="100"></vxe-column>
                <vxe-column field="createTime" title="创建时间" width="170" sortable>
                    <template v-slot="{ row }">
                        <span>{{row.createTime ? row.createTime.replace('T', ' ').substring(0, 19) : ''}}</span>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="wmsGetPylkListPager" size="mini">
        </vxe-pager>
        <!-- 新增盘盈盘亏弹出框 -->
        <el-dialog title="新增盘盈盘亏" width="95%"  :visible.sync="addPylkVisible" :before-close="addPylkClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-form ref="addPylkForm" :model="addPylkForm" :rules="addPylkRules" size="mini" label-width="110px">
                <el-divider content-position="left">盈亏信息</el-divider>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="盈亏类型" prop="plType">
                            <el-select class="width_100" v-model="addPylkForm.plType" placeholder="请选择盈亏类型" clearable>
                                <el-option v-for="item in plTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="盈亏原因" prop="reason">
                            <el-input clearable v-model="addPylkForm.reason" placeholder="请输入盈亏原因"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="责任人" prop="responsible">
                            <el-input clearable v-model="addPylkForm.responsible" placeholder="请输入责任人"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="入库日期" prop="createDate">
                            <el-date-picker class="width_100" v-model="addPylkForm.createDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="请选择入库日期" clearable></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">仓库信息</el-divider>
                <el-row>
                     <el-col :span="4">
                        <el-form-item label="仓库" prop="ckName">
                            <el-select class="width_100" @change="ckNameEnter" v-model="addPylkForm.ckName" placeholder="请选择仓库" clearable>
                                <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="库区" prop="place">
                            <el-select class="width_100" @change="placeEnter" v-model="addPylkForm.place" placeholder="请选择库区" filterable>
                                <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="库位" prop="location">
                            <el-select class="width_100" filterable v-model="addPylkForm.location" placeholder="请选择库位">
                                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                                    </el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="保税类型" prop="isBonded">
                            <el-select class="width_100" v-model="addPylkForm.isBonded" placeholder="请选择保税类型" clearable @change="changeIsBonded">
                                <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="账册编号" prop="handbook">
                            <el-select placeholder="请选择账册编号" v-model="addPylkForm.handbook" >
                                <el-option v-for="item in handBookNoList" :key="item.bookNo" :label="item.bookNo" :value="item.bookNo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">货物信息</el-divider>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="委托单位" prop="customer">
                            <el-select class="width_100" filterable v-model="addPylkForm.customer" placeholder="请选择委托单位" clearable @change="changeCustomer">
                                <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="货主单位" prop="ownerName">
                            <el-select class="width_100" filterable v-model="addPylkForm.ownerName" placeholder="请选择货主单位" clearable >
                                <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="提单号" prop="blNo">
                            <el-input clearable v-model="addPylkForm.blNo" placeholder="请输入提单号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="报关单号" prop="cusDeclNo">
                            <el-input clearable v-model="addPylkForm.cusDeclNo" placeholder="请输入报关单号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="核注清单号" prop="invDecNo">
                            <el-input clearable v-model="addPylkForm.invDecNo" placeholder="请输入核注清单号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="货物名称" prop="goodsName">
                            <el-select class="width_100" filterable remote :remote-method="getGoodsList" :default-first-option="true"
                                v-model="addPylkForm.goodsName" placeholder="请选择货物名称" clearable @change="goodsEnter($event)">
                                <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName + '-' + item.goodsType + '-' + item.hsCode">
                                    <span class="margin_right_20">{{ item.goodsName }}</span>
                                    <span class="margin_right_20">{{ item.goodsType }}</span>
                                    <span>{{ item.hsCode }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="货物分类" prop="goodsType">
                            <!--  -->
                            <el-input :disabled="true" clearable v-model="addPylkForm.goodsType" placeholder="请输入货物分类"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="海关编码" prop="hsCode">
                            <!-- :disabled="true" -->
                            <el-input  clearable v-model="addPylkForm.hsCode" placeholder="请输入海关编码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="箱号" prop="boxNo">
                            <el-input clearable v-model="addPylkForm.boxNo" placeholder="请输入箱号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="铅封号" prop="sealNo">
                            <el-input clearable v-model="addPylkForm.sealNo" placeholder="请输入箱号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="商品料号" prop="skuNo">
                            <el-input clearable v-model="addPylkForm.skuNo" placeholder="请输入商品料号"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="10">
                        <el-form-item label="规格型号" prop="spec">
                            <el-input clearable v-model="addPylkForm.spec" placeholder="请输入规格型号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="币制" :prop="addPylkForm.isBonded === '保税' ? 'decCurrency' : ''">
                            <el-select class="width_100" filterable :default-first-option="true" v-model="addPylkForm.decCurrency" placeholder="请选择币制" clearable>
                                <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span class="margin_right_20">{{ item.codeName }}</span>
                                    <span >{{ item.cusCode }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="原产地" prop="originCountry">
                            <el-select class="width_100" filterable remote :remote-method="getCountryList" :default-first-option="true"
                                v-model="addPylkForm.originCountry" placeholder="请选择原产地" clearable>
                                <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                    <!-- <el-col :span="6">
                        <el-form-item label="包装种类" prop="packageType">
                            <el-select class="width_100" filterable v-model="addPylkForm.packageType" placeholder="请选择包装种类" clearable>
                                <el-option v-for="item in packageTypeList" :key="item.packType" :label="item.packType + ' - ' + item.packTypeName" :value="item.packType">
                                    <span class="margin_right_20">{{ item.packType }}</span>
                                    <span >{{ item.packTypeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="净重(KG)" prop="netWeight">
                            <el-input clearable v-model="addPylkForm.netWeight" placeholder="请输入净重" @blur="blurNetWeight"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="件数1" prop="qty1">
                            <el-input clearable v-model="addPylkForm.qty1" placeholder="请输入件数1"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="件数1单位" prop="qty1Unit">
                            <el-select class="width_100" filterable :default-first-option="true" v-model="addPylkForm.qty1Unit" placeholder="请选择件数1单位" clearable>
                                <el-option v-for="item in unitList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="件数2" prop="qty2">
                            <el-input clearable v-model="addPylkForm.qty2" placeholder="请输入件数2"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="件数2单位" prop="qty2Unit">
                            <el-select class="width_100" filterable :default-first-option="true" v-model="addPylkForm.qty2Unit" placeholder="请选择件数2单位" clearable>
                                <el-option v-for="item in unitList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="单价" :prop="addPylkForm.isBonded === '保税' ? 'decPrice' : ''">
                            <el-input clearable v-model="addPylkForm.decPrice" placeholder="请输入单价" @blur="blurDecPrice"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报金额" :prop="addPylkForm.isBonded === '保税' ? 'decAmount' : ''">
                            <el-input clearable v-model="addPylkForm.decAmount" placeholder="请输入申报金额"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报数量" :prop="addPylkForm.isBonded === '保税' ? 'decNum' : ''">
                            <el-input clearable v-model="addPylkForm.decNum" placeholder="请输入申报数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报单位" :prop="addPylkForm.isBonded === '保税' ? 'decUnit' : ''">
                            <el-select class="width_100" filterable :default-first-option="true" v-model="addPylkForm.decUnit" placeholder="请选择申报单位" clearable>
                                <el-option v-for="item in unitList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="项号" :prop="addPylkForm.isBonded === '保税' ? 'itemNo' : ''">
                            <el-input clearable v-model="addPylkForm.itemNo" placeholder="请输入项号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="法定第一数量" :prop="addPylkForm.lawUnitFirst ? 'firstNum' : ''">
                            <!-- :disabled="!addPylkForm.lawUnitFirst" -->
                            <el-input  clearable v-model="addPylkForm.firstNum" placeholder="请输入法定第一数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="法定第一单位" prop="lawUnitFirst">
                            <el-select  class="width_100" filterable :default-first-option="true" v-model="addPylkForm.lawUnitFirst" placeholder="请选择法定第一单位" clearable @change="changeLawUnitFirst">
                                <el-option v-for="item in unitList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="法定第二数量" :prop="addPylkForm.lawUnitSecond ? 'secondNum' : ''">
                            <!-- :disabled="!addPylkForm.lawUnitSecond" -->
                            <el-input  clearable v-model="addPylkForm.secondNum" placeholder="请输入法定第二数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'') || ''"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="法定第二单位" prop="lawUnitSecond">
                            <el-select  class="width_100" filterable :default-first-option="true" v-model="addPylkForm.lawUnitSecond" placeholder="请选择法定第二单位" clearable @change="changeLawUnitSecond">
                                <el-option v-for="item in unitList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                    <span class="margin_right_20">{{ item.codeValue }}</span>
                                    <span >{{ item.codeName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="addPylkClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveAddPylk">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 盘盈盘亏详情弹出框 -->
        <el-dialog title="盘盈盘亏详情" width="75%" :visible.sync="pylkDetailVisible" :before-close="pylkDetailClose" v-dialogDrag
            :close-on-click-modal="false">
            <!-- 展示顺序与新增盘盈盘亏表单保持一致 -->
            <el-descriptions title="" :column="5" size="medium" border>
                <el-descriptions-item label="盈亏类型">{{ pylkDetailRows.plType }}</el-descriptions-item>
                <el-descriptions-item label="盈亏原因">{{ pylkDetailRows.reason }}</el-descriptions-item>
                <el-descriptions-item label="责任人">{{ pylkDetailRows.responsible }}</el-descriptions-item>
                <el-descriptions-item label="创建日期" :span="2">{{ pylkDetailRows.createDate }}</el-descriptions-item>
                <el-descriptions-item label="仓库">{{ pylkDetailRows.ckName }}</el-descriptions-item>
                <el-descriptions-item label="库区">{{ pylkDetailRows.place }}</el-descriptions-item>
                <el-descriptions-item label="库位">{{ pylkDetailRows.location }}</el-descriptions-item>
                <el-descriptions-item label="保税类型">{{ pylkDetailRows.isBonded }}</el-descriptions-item>
                <el-descriptions-item label="账册编号">{{ pylkDetailRows.handbook }}</el-descriptions-item>
                <el-descriptions-item label="委托单位">{{ pylkDetailRows.customer }}</el-descriptions-item>
                <el-descriptions-item label="货主单位">{{ pylkDetailRows.ownerName }}</el-descriptions-item>
                <el-descriptions-item label="提单号">{{ pylkDetailRows.blNo }}</el-descriptions-item>
                <el-descriptions-item label="报关单号">{{ pylkDetailRows.cusDeclNo }}</el-descriptions-item>
                <el-descriptions-item label="核注清单号">{{ pylkDetailRows.invDecNo }}</el-descriptions-item>
                <el-descriptions-item label="货物名称">{{ pylkDetailRows.goodsName }}</el-descriptions-item>
                <el-descriptions-item label="货物分类">{{ pylkDetailRows.goodsType }}</el-descriptions-item>
                <el-descriptions-item label="海关编码">{{ pylkDetailRows.hsCode }}</el-descriptions-item>
                <el-descriptions-item label="箱号">{{ pylkDetailRows.boxNo }}</el-descriptions-item>
                <el-descriptions-item label="铅封号">{{ pylkDetailRows.sealNo }}</el-descriptions-item>
                <el-descriptions-item label="商品料号">{{ pylkDetailRows.skuNo }}</el-descriptions-item>
                <el-descriptions-item label="规格型号" :span="2">{{ pylkDetailRows.spec }}</el-descriptions-item>
                <el-descriptions-item label="币制">{{ findCurrencyNameByCode(pylkDetailRows.decCurrency) }}</el-descriptions-item>
                <el-descriptions-item label="原产地">{{ pylkDetailRows.originCountry }}</el-descriptions-item>
                <el-descriptions-item label="净重(KG)">{{ pylkDetailRows.netWeight }}</el-descriptions-item>
                <el-descriptions-item label="件数1">{{ pylkDetailRows.qty1 }}</el-descriptions-item>
                <el-descriptions-item label="件数1单位">{{ findUnitNameByCode(pylkDetailRows.qty1Unit) }}</el-descriptions-item>
                <el-descriptions-item label="件数2">{{ pylkDetailRows.qty2 }}</el-descriptions-item>
                <el-descriptions-item label="件数2单位">{{ findUnitNameByCode(pylkDetailRows.qty2Unit) }}</el-descriptions-item>
                <el-descriptions-item label="单价">{{ pylkDetailRows.decPrice }}</el-descriptions-item>
                <el-descriptions-item label="申报金额">{{ pylkDetailRows.decAmount }}</el-descriptions-item>
                <el-descriptions-item label="申报数量">{{ pylkDetailRows.decNum }}</el-descriptions-item>
                <el-descriptions-item label="申报单位">{{ findUnitNameByCode(pylkDetailRows.decUnit) }}</el-descriptions-item>
                <el-descriptions-item label="项号">{{ pylkDetailRows.itemNo }}</el-descriptions-item>
                <el-descriptions-item label="法定第一数量">{{ pylkDetailRows.firstNum }}</el-descriptions-item>
                <el-descriptions-item label="法定第一单位">{{ findUnitNameByCode(pylkDetailRows.lawUnitFirst) }}</el-descriptions-item>
                <el-descriptions-item label="法定第二数量">{{ pylkDetailRows.secondNum }}</el-descriptions-item>
                <el-descriptions-item label="法定第二单位">{{ findUnitNameByCode(pylkDetailRows.lawUnitSecond) }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="pylkDetailClose">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import clean from 'lodash-clean';
import AEObasicData from '@/config/AEObasicData.js'
export default {
    name: 'inventoryProfitLoss',
    components:{
    },
    watch: {

    },
    data() {
        return{
            createDate:[],// 创建日期列表
            pylkSearchForm:{
                plType:'', // 盈亏类型
                billNo:'', // 盈亏单号
                blNo:'', // 提单号
                goodsName:'', // 货名
                startDate:"", // 创建日期开始
                endDate:"", // 创建日期结束
            },
            pylkList:[], // 盘盈盘亏列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 20, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            // 盈亏类型列表
            plTypeList:[
                {
                    value: '盘盈',
                    label: '盘盈'
                }, {
                    value: '盘亏',
                    label: '盘亏'
                }
            ],
            // 新增盘盈盘亏弹窗
            addPylkVisible:false, // 新增弹窗是否显示
            // 盘盈盘亏详情弹窗
            pylkDetailVisible:false, // 详情弹窗是否显示
            pylkDetailRows:{}, // 详情数据
            addPylkForm:{
                plType:'', // 盈亏类型
                blNo:'', // 提单号
                ckName:'', // 仓库
                isBonded:'', // 保税类型
                ownerName:'', // 货主单位
                customer:'', // 委托单位
                handbook:'', // 账册编号
                skuNo:'', // 商品料号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                itemNo:'', // 项号
                boxNo:'', // 箱号
                sealNo:'', // 铅封号
                goodsName:'', // 货物名称
                spec:'', // 规格型号
                goodsType:'', // 货物分类
                hsCode:'', // 海关编码
                place:'', // 库区
                location:'', // 库位
                packageType:'', // 包装种类
                originCountry:'', // 原产地
                qty1Unit:'', // 件数1单位
                qty1:'', // 件数1
                qty2Unit:'', // 件数2单位
                qty2:'', // 件数2
                netWeight:'', // 净重(KG)
                decNum:'', // 申报数量
                decPrice:'', // 申报单价
                decAmount:'', // 申报金额
                decCurrency:'', // 币制
                decUnit:'', // 申报单位
                lawUnitFirst:'', // 法定第一单位
                firstNum:'', // 法定第一数量
                lawUnitSecond:'', // 法定第二单位
                secondNum:'', // 法定第二数量
                reason:'', // 盈亏原因
                responsible:'', // 责任人
                note:'', // 备注
                remark:'', // 备注说明
                createDate:'', // 创建日期
            },// 新增盘盈盘亏数据
            addPylkRules:{
                plType:[
                    { required: true, message: '请选择盈亏类型', trigger: 'change' },
                ],
                reason:[
                    { required: true, message: '请输入盈亏原因', trigger: 'blur' },
                ],
                responsible:[
                    { required: true, message: '请输入责任人', trigger: 'blur' },
                ],
                createDate:[
                    { required: true, message: '请选择入库日期', trigger: 'change' },
                ],
                ckName:[
                    { required: true, message: '请选择仓库', trigger: 'change' },
                ],
                place:[
                    { required: true, message: '请选择库区', trigger: 'change' },
                ],
                location:[
                    { required: true, message: '请选择库位', trigger: 'change' },
                ],
                isBonded:[
                    { required: true, message: '请选择保税类型', trigger: 'change' },
                ],
                customer:[
                    { required: true, message: '请选择委托单位', trigger: 'change' },
                ],
                ownerName:[
                    { required: true, message: '请选择货主单位', trigger: 'change' },
                ],
                blNo:[
                    { required: true, message: '请输入提单号', trigger: 'blur' },
                ],
                goodsName:[
                    { required: true, message: '请选择货物名称', trigger: 'change' },
                ],

                // skuNo:[
                //     { required: true, message: '请输入商品料号', trigger: 'blur' },
                // ],
                spec:[
                    { required: true, message: '请输入规格型号', trigger: 'blur' },
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                ],
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                ],
                qty1Unit:[
                    { required: true, message: '请选择件数1单位', trigger: 'change' },
                ],
                // 法定第一/第二数量：法定单位是自动带出且不可编辑的，没有单位时数量不允许填写，所以有单位才校验
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                ],
                // 以下字段只有保税时才必填（是否校验由表单项上的 :prop 控制）
                decCurrency:[
                    { required: true, message: '请选择币制', trigger: 'change' },
                ],
                decPrice:[
                    { required: true, message: '请输入单价', trigger: 'blur' },
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                ],
                decUnit:[
                    { required: true, message: '请选择申报单位', trigger: 'change' },
                ],
                itemNo:[
                    { required: true, message: '请输入项号', trigger: 'blur' },
                ],
            },
            ckNameList:[], // 仓库列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            customerList:[], // 货主/委托单位列表
            goodsList:[], // 货物名称列表
            bondedTypeList:[], // 保税属性列表
            countryList:[], // 原产地列表
            handBookNoList:[], // 账册列表
            currencyList:AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            packageTypeList:AEObasicData.CUS_MAPPING_PACKAGEKIND_CODE_V, // 包装种类
        }
    },
    created() {
        this.wmsGetPylkList()
        this.getckNameList()
        this.getCustomerList()
        this.getIsBonded()
    },
    mounted() {

    },
    methods: {
        // 重置表单
        resetForm(){
            this.createDate = []
            this.pylkSearchForm = {
                plType:'', // 盈亏类型
                billNo:'', // 盈亏单号
                blNo:'', // 提单号
                goodsName:'', // 货名
                startDate:"", // 创建日期开始
                endDate:"", // 创建日期结束
            }
        },
        // 创建日期获取
        getCreateDate(data){
            if(data === null){
                this.pylkSearchForm.startDate = ''
                this.pylkSearchForm.endDate = ''
            }else{
                this.pylkSearchForm.startDate = data[0]
                this.pylkSearchForm.endDate = data[1]
            }
        },
        // 搜索盘盈盘亏
        wmsGetPylkList(){
            this.pagination.currentPage = 1
            this.$api.wmsGetPylkList(this.pagination.currentPage,this.pagination.pageSize,clean(this.pylkSearchForm) ).then(res =>{
                this.pylkList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 搜索盘盈盘亏分页
        wmsGetPylkListPager(){
            this.$api.wmsGetPylkList(this.pagination.currentPage,this.pagination.pageSize,clean(this.pylkSearchForm) ).then(res =>{
                this.pylkList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取货主/委托单位
        getCustomerList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedTypeList = res
            })
        },
        // 查询原产地
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 获取货物名称列表（远程搜索）
        getGoodsList(value){
            this.$api.getInUseListBy( {param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        },
        // 根据计量单位名称匹配AEO标准计量单位代码
        findUnitCodeByName(name){
            if(!name){
                return ''
            }
            const unit = this.unitList.filter(item =>
                item.codeName && item.codeName.toLowerCase().includes(name.toLowerCase())
            )[0]
            return unit ? unit.codeValue : ''
        },
        // 选择货物名称后，自动带出货物分类、海关编码、法一单位、法二单位、申报单位
        goodsEnter(value){
            if(!value){
                this.addPylkForm.goodsName = ''
                this.addPylkForm.goodsType = ''
                this.addPylkForm.hsCode = ''
                this.addPylkForm.lawUnitFirst = ''
                this.addPylkForm.lawUnitSecond = ''
                // 没有法一/法二单位时，对应的数量不允许有值
                this.addPylkForm.firstNum = ''
                this.addPylkForm.secondNum = ''
                return
            }
            // 下拉选项的值是：货物名称-货物分类-海关编码
            const item = value.split('-')
            this.addPylkForm.goodsName = item[0]
            this.addPylkForm.goodsType = item[1]
            this.addPylkForm.hsCode = item[2]
            if(!item[2]){
                // 没有海关编码时带不出法一/法二单位和申报单位
                this.addPylkForm.lawUnitFirst = ''
                this.addPylkForm.lawUnitSecond = ''
                this.addPylkForm.decUnit = ''
                this.addPylkForm.firstNum = ''
                this.addPylkForm.secondNum = ''
                return
            }
            // 根据海关编码查询法一、法二、申报单位
            this.$api.getHsCiqByHsCode( item[2] ).then(res =>{
                this.addPylkForm.lawUnitFirst = this.findUnitCodeByName(res.firstLawUnit)
                this.addPylkForm.decUnit = this.findUnitCodeByName(res.hsUnit && res.hsUnit.includes('/') ? res.hsUnit.split('/')[0] : res.hsUnit)
                this.addPylkForm.lawUnitSecond = (res.secondLawUnit === '无' || !res.secondLawUnit) ? '' : this.findUnitCodeByName(res.secondLawUnit)
                // 没有法二单位时，法二数量不允许有值
                if(!this.addPylkForm.lawUnitSecond){
                    this.addPylkForm.secondNum = ''
                }
                // 法一单位带出后，如果净重已填写，法一数量跟随净重
                if(this.addPylkForm.lawUnitFirst && this.addPylkForm.netWeight){
                    this.addPylkForm.firstNum = this.addPylkForm.netWeight
                }
                this.$forceUpdate();
            })
        },
        // 法一单位清空时，法一数量同步清空
        changeLawUnitFirst(value){
            if(!value){
                this.addPylkForm.firstNum = ''
            }
        },
        // 法二单位清空时，法二数量同步清空
        changeLawUnitSecond(value){
            if(!value){
                this.addPylkForm.secondNum = ''
            }
        },
        // 打开新增弹窗
        addPylk(){
            this.addPylkVisible = true
        },
        // 查询盘盈盘亏详情
        getPylkDetails(row){
            this.$api.wmsGetPylk( row.id ).then(res =>{
                this.pylkDetailRows = res
                this.pylkDetailVisible = true
            })
        },
        // 双击表格行查看盘盈盘亏详情
        getPylkDetailDblclick({ row }){
            this.getPylkDetails(row)
        },
        // 关闭详情弹窗
        pylkDetailClose(){
            this.pylkDetailVisible = false
            this.pylkDetailRows = {}
        },
        // 根据计量单位代码匹配单位名称
        findUnitNameByCode(code){
            if(!code){
                return ''
            }
            const unit = this.unitList.filter(item => item.codeValue === code)[0]
            return unit ? unit.codeName : code
        },
        // 根据币制代码匹配币制名称
        findCurrencyNameByCode(code){
            if(!code){
                return ''
            }
            const currency = this.currencyList.filter(item => item.codeValue === code)[0]
            return currency ? currency.codeName : code
        },
        // 选择仓库后查询库区
        ckNameEnter(value){
            this.addPylkForm.place = ''
            this.addPylkForm.location = ''
            this.locationList = []
            // 获取库区列表
            this.$api.getStore( value ).then(res =>{
                this.placeList = res
            })
            if( this.addPylkForm.isBonded &&  this.addPylkForm.ckName){
                this.gethandBookNoList()
            }
        },
        // 选择库区后查询库位
        placeEnter(value){
            this.addPylkForm.place = value.split('-')[0]
            this.addPylkForm.location = ''
            this.$api.getLocation( value.split('-')[1] ).then(res =>{
                this.locationList = res
            })
        },
        // 当选择客户的时候自动给货主赋值
        changeCustomer(){
            this.addPylkForm.ownerName = this.addPylkForm.customer
        },
        // 当非保税的时候清空报关单号和核注清单,查询账册
        changeIsBonded(){
            if( this.addPylkForm.isBonded &&  this.addPylkForm.ckName){
                this.gethandBookNoList()
            }
            if( this.addPylkForm.isBonded === '非保税' ){
                this.addPylkForm.cusDeclNo = ''
                this.addPylkForm.invDecNo = ''
            }
        },
         // 查询账册
        gethandBookNoList(){
            const parms = {
                type:this.addPylkForm.isBonded,
                ckName:this.addPylkForm.ckName
            }
            this.$api.wmsgetHandBook( parms ).then(res =>{
                this.handBookNoList = res.tableData
                if(this.handBookNoList.length){
                    this.addPylkForm.handbook = this.handBookNoList[0].bookNo
                }else{
                    this.addPylkForm.handbook = ''
                }
                // 默认赋值第一个
            })
        },
        // 关闭新增弹窗
        addPylkClose(){
            this.addPylkVisible = false
            this.$nextTick(()=>{
                this.$refs.addPylkForm.resetFields();
            })
            this.addPylkForm = {
                plType:'', // 盈亏类型
                blNo:'', // 提单号
                ckName:'', // 仓库
                isBonded:'', // 保税类型
                ownerName:'', // 货主单位
                customer:'', // 委托单位
                handbook:'', // 账册编号
                skuNo:'', // 商品料号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                itemNo:'', // 项号
                boxNo:'', // 箱号
                sealNo:'', // 铅封号
                goodsName:'', // 货物名称
                spec:'', // 规格型号
                goodsType:'', // 货物分类
                hsCode:'', // 海关编码
                place:'', // 库区
                location:'', // 库位
                packageType:'', // 包装种类
                originCountry:'', // 原产地
                qty1Unit:'', // 件数1单位
                qty1:'', // 件数1
                qty2Unit:'', // 件数2单位
                qty2:'', // 件数2
                netWeight:'', // 净重(KG)
                decNum:'', // 申报数量
                decPrice:'', // 申报单价
                decAmount:'', // 申报金额
                decCurrency:'', // 币制
                decUnit:'', // 申报单位
                lawUnitFirst:'', // 法定第一单位
                firstNum:'', // 法定第一数量
                lawUnitSecond:'', // 法定第二单位
                secondNum:'', // 法定第二数量
                reason:'', // 盈亏原因
                responsible:'', // 责任说明
                note:'', // 备注
                remark:'', // 备注说明
                createDate:'', // 创建日期
            }
        },
        // 输入净重时，同步申报数量、法定第一数量，如果单价有值则计算申报金额
        blurNetWeight(){
            this.addPylkForm.decNum = this.addPylkForm.netWeight
            this.addPylkForm.firstNum = this.addPylkForm.lawUnitFirst ? this.addPylkForm.netWeight : ''
            if(this.addPylkForm.decPrice){
                const decAmount = this.addPylkForm.netWeight * this.addPylkForm.decPrice
                this.addPylkForm.decAmount = Math.round(decAmount * 10000) / 10000
            }
            this.$forceUpdate();
        },
        // 输入申报单价时，如果申报数量有值则计算申报金额
        blurDecPrice(){
            if(this.addPylkForm.netWeight){
                const product = this.addPylkForm.netWeight * this.addPylkForm.decPrice
                this.addPylkForm.decAmount = Math.round(product * 10000) / 10000
            }
            this.$forceUpdate();
        },
        // 新增盘盈盘亏
        saveAddPylk(){
            this.$confirm('是否确定新增盘盈盘亏?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.addPylkForm.validate((valid) => {
                    if (valid) {
                        this.$api.wmsAddPylk( clean(this.addPylkForm) ).then(res =>{
                            this.$message({
                                message: '新增盘盈盘亏成功',
                                type: 'success'
                            });
                            this.addPylkClose()
                            this.wmsGetPylkList()
                        })
                    } else {
                        this.$message.error('请填写必填字段')
                        return false;
                    }
                })
            }).catch(() => { });
            
        },
    }
}
</script>
<style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 10px;
}
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
</style>
